module.exports = __webpack_public_path__ + "img/point_completed.27027764.svg";